import { getData, postData, putData } from "./axiosConfig"

export const payout = async (body) => {
    return await postData('/wallet/payout-request', body)
}
export const createAccount = async (body) => {
    return await postData('/account-create', body)
}

export const transactionHistory = async () => {
    return await getData('/wallet/transactions')
}
export const withdrawalHistory = async () => {
    return await getData('/wallet/transactions-history')
}

export const me = async (id) => {
    return await getData(`/me/${id}`)
}

export const updateProfile = async (body) => {
    return await putData('/profile-update', body)
}
export const updatePassword = async (body) => {
    return await putData("/password-update", body)
}

export const withdrawableTransactions = async () => {
    return await getData('/wallet/withdrawable-transactions')
}

export const withdrawlRequest = async (body) => {
    return await postData('/wallet/withdrawl-request', body)
}